// extracted by mini-css-extract-plugin
export default {"info__label":"SectionTitle_info__label__th-+H","info__title":"SectionTitle_info__title__Du5A6"};